/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Resource Explorer Service API
 * OpenAPI spec version: 0.1.0
 */

export type CategoryIconID = (typeof CategoryIconID)[keyof typeof CategoryIconID];

export const CategoryIconID = {
  ADMINISTRATIVE_TOOLS: 'administrative-tools',
  ANCILLARY_SERVICES: 'ancillary-services',
  CENTER: 'center',
  CERTIFICATE: 'certificate',
  CHECK_LIST: 'check-list',
  CLINICAL_TRANSLATIONAL: 'clinical-translational',
  COMMUNICATE: 'communicate',
  COMMUNITY_CATEGORY: 'community-category',
  DATA_MANAGEMENT: 'data-management',
  DATA_SCIENCE: 'data-science',
  DESIGN: 'design',
  FACILITY: 'facility',
  FUNDING: 'funding',
  GRANT: 'grant',
  LOGISTICS: 'logistics',
  MANAGEMENT: 'management',
  PARTICIPATE: 'participate',
  REGULATIONS: 'regulations',
  RESEARCH: 'research',
  SPECIAL_TOPICS: 'special-topics',
  TRAINING: 'training',
  WRITING: 'writing',
} as const;
